<template>
  <div class="list-page-container">
    <div class="control-panel">
      <div class="control-container">
        <div class="header-info">
          <i class="el-icon-s-order"></i>
          <span>管理权益兑换记录，查看兑换详情与核销</span>
        </div>
      </div>
    </div>

    <div class="control-panel has-query">
      <div class="control-container">
        <el-form :inline="true" :model="searchForm" class="filter-form" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="searchForm.userId" placeholder="用户ID" clearable class="filter-input" @keyup.enter.native="handleSearch" @clear="handleSearch">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.goodsId" placeholder="权益ID" clearable class="filter-input" @keyup.enter.native="handleSearch" @clear="handleSearch"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.status" placeholder="兑换状态" clearable class="filter-select" @change="handleSearch">
              <el-option label="待使用" value="UNUSED"></el-option>
              <el-option label="已使用" value="USED"></el-option>
              <el-option label="已过期" value="EXPIRED"></el-option>
              <el-option label="已取消" value="CANCELLED"></el-option>
            </el-select>
          </el-form-item>
          <div class="search-btns">
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          </div>
        </el-form>
      </div>
    </div>

    <div class="statistics-panel" v-if="statistics">
      <div class="stat-card stat-total">
        <div class="stat-value">{{ statistics.total || 0 }}</div>
        <div class="stat-label">全部记录</div>
      </div>
      <div class="stat-card stat-unused">
        <div class="stat-value">{{ statistics.unused || 0 }}</div>
        <div class="stat-label">待使用</div>
      </div>
      <div class="stat-card stat-used">
        <div class="stat-value">{{ statistics.used || 0 }}</div>
        <div class="stat-label">已使用</div>
      </div>
      <div class="stat-card stat-expired">
        <div class="stat-value">{{ statistics.expired || 0 }}</div>
        <div class="stat-label">已过期</div>
      </div>
      <div class="stat-card stat-cancelled">
        <div class="stat-value">{{ statistics.cancelled || 0 }}</div>
        <div class="stat-label">已取消</div>
      </div>
    </div>

    <el-card class="list-card">
      <el-table ref="table" :data="tableData" v-loading="loading" class="custom-table" height="100%" style="width: 100%">
        <el-table-column prop="id" label="ID" width="70" align="center" v-if="false"></el-table-column>
        <el-table-column prop="userName" label="用户" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.userName || '-' }}</template>
        </el-table-column>
        <el-table-column label="权益商品" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-image v-if="scope.row.goodsIcon" :src="resolveUrl(scope.row.goodsIcon)" fit="cover" style="width: 28px; height: 28px; border-radius: 4px; flex-shrink: 0;"></el-image>
              <span>{{ scope.row.goodsName || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="rightsType" label="类型" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" effect="plain" :type="getTypeTagType(scope.row.rightsType)">{{ getTypeLabel(scope.row.rightsType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pointsCost" label="消耗积分" width="100" align="center">
          <template slot-scope="scope">
            <span style="color: #e6a23c; font-weight: 600;">{{ scope.row.pointsCost || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="mini" effect="plain">{{ getStatusLabel(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="exchangeTime" label="兑换时间" width="160" align="center">
          <template slot-scope="scope">{{ formatDate(scope.row.exchangeTime) }}</template>
        </el-table-column>
        <el-table-column prop="exchangeIp" label="兑换IP" width="130" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.exchangeIp || '-' }}</template>
        </el-table-column>
        <el-table-column v-if="hasAnyActionPermission" :label="$t('common.operation')" :width="actionColumnWidth" fixed="right" align="center">
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button v-if="scope.row.status === 'UNUSED' && hasPermission('activity:shop:update')" class="btn-action-audit" size="mini" plain icon="el-icon-check" @click="handleUse(scope.row)">核销</el-button>
              <el-button v-if="scope.row.status === 'UNUSED' && hasPermission('activity:shop:update')" type="warning" size="mini" plain icon="el-icon-close" @click="handleCancel(scope.row)">取消</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getRightsExchangePage,
  getRightsExchangeStatistics,
  useRightsExchange,
  cancelRightsExchange
} from '@/apis/activity/rights'
import { getDictDataByType } from '@/apis/system/dict'
import { hasPermission } from '@/utils/permission'
import { getFullUrl } from '@/utils'

export default {
  name: 'RightsExchangeList',
  data() {
    return {
      loading: false,
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      searchForm: { userId: '', goodsId: '', status: '' },
      statistics: null,
      rightsTypeMap: {}
    }
  },
  created() {
    this.loadDictData()
    this.loadData()
    this.loadStatistics()
  },
  computed: {
    visibleActionCount() {
      let count = 0
      if (this.hasPermission('activity:shop:update')) count += 2
      return count
    },
    hasAnyActionPermission() {
      return this.visibleActionCount > 0
    },
    actionColumnWidth() {
      const count = this.visibleActionCount
      const widthMap = { 1: 100, 2: 170, 3: 245 }
      return widthMap[count] || 0
    }
  },
  methods: {
    hasPermission,
    resolveUrl(url) { return getFullUrl(url) },
    loadDictData() {
      getDictDataByType('RIGHTS_TYPE').then(res => {
        const data = res || []
        this.rightsTypeMap = {}
        data.forEach(item => { this.rightsTypeMap[item.key] = item.name })
      }).catch(e => {
        console.error('加载权益类型字典失败:', e)
      })
    },
    loadData() {
      this.loading = true
      const params = {
        page: this.page,
        limit: this.limit,
        userId: this.searchForm.userId || undefined,
        goodsId: this.searchForm.goodsId || undefined,
        status: this.searchForm.status || undefined
      }
      getRightsExchangePage(params).then(res => {
        if (res) {
          this.tableData = res.list || []
          this.total = res.total || 0
        }
      }).catch(e => {
        console.error('加载兑换记录失败:', e)
      }).finally(() => {
        this.loading = false
      })
    },
    loadStatistics() {
      getRightsExchangeStatistics({}).then(res => {
        if (res) this.statistics = res
      }).catch(e => {
        console.error('加载兑换统计失败:', e)
      })
    },
    handleSearch() { this.page = 1; this.loadData() },
    handleReset() { this.searchForm = { userId: '', goodsId: '', status: '' }; this.page = 1; this.loadData() },
    handleSizeChange(val) { this.limit = val; this.page = 1; this.loadData() },
    handleCurrentChange(val) { this.page = val; this.loadData() },
    handleUse(row) {
      this.$confirm('确认核销该兑换记录？', '核销确认', { type: 'warning' }).then(() => {
        useRightsExchange(row.id).then(() => {
          this.$message.success('核销成功')
          this.loadData()
          this.loadStatistics()
        })
      }).catch(() => {})
    },
    handleCancel(row) {
      this.$confirm('确认取消该兑换？积分将退还用户', '取消确认', { type: 'warning' }).then(() => {
        cancelRightsExchange(row.id).then(() => {
          this.$message.success('取消成功，积分已退还')
          this.loadData()
          this.loadStatistics()
        })
      }).catch(() => {})
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const d = new Date(dateStr)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    getTypeLabel(val) { return this.rightsTypeMap[val] || val || '-' },
    getTypeTagType(val) { const map = { TICKET: '', EXPERIENCE: 'success', HIDDEN: 'danger' }; return map[val] || 'info' },
    getStatusLabel(status) { const map = { UNUSED: '待使用', USED: '已使用', EXPIRED: '已过期', CANCELLED: '已取消' }; return map[status] || status },
    getStatusType(status) { const map = { UNUSED: 'warning', USED: 'success', EXPIRED: 'info', CANCELLED: 'danger' }; return map[status] || 'info' }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/list-page.scss";

.statistics-panel {
  display: flex;
  gap: 12px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.stat-card {
  flex: 1;
  min-width: 100px;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  border: 1px solid #f1f5f9;
  border-left: 3px solid #409eff;
  transition: box-shadow 0.3s;

  &:hover {
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);
  }

  &.stat-unused { border-left-color: #e6a23c; }
  &.stat-used { border-left-color: #67c23a; }
  &.stat-expired { border-left-color: #909399; }
  &.stat-cancelled { border-left-color: #f56c6c; }
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #303133;
}

.stat-label {
  font-size: 13px;
  color: #909399;
  margin-top: 4px;
}
</style>
